export default __webpack_public_path__ + "static/media/sec-3d.88597607.png";